import { ChangeEvent } from "react";
import { Link } from "react-router-dom";

import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { PatientEdit } from "@/Common/Components/Patient/PatientEdit";
import { PortalStatusIcon } from "@/Common/Components/Portal/PortalStatusIcon";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { PortalHelper } from "@/Common/Helpers/PortalHelper";
import { Guid } from "@/Common/Models/Guid";
import { Person } from "@/Common/Models/Person/Person";
import { RAMQInfo } from "@/Common/Models/RAMQ/RAMQInfo";
import { ISidebarModel } from "@/Common/Models/UI/Sidebar/ISidebarModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ButtonImageControl } from "../Buttons/ButtonImageControl";

import "./sidebar.css";

import img_icon_create_patient from "@/Globals/_images/icons/sidebar/create-patient.png";

interface ISidebarProps {
    Model: ISidebarModel;
    CalendarControlId?: string;
    SearchResultClickDisabled?: boolean
}

class Sidebar extends React.Component<ISidebarProps, never> {
    private calendarControlId: string;
    private resizeTimeout: number = -1;
    private keyEventBound: boolean;

    constructor(props: ISidebarProps) {
        super(props);

        this.keyEventBound = false;
        this.calendarControlId = GuidHelper.NewGuid();

        if (props.CalendarControlId != null) {
            if (props.CalendarControlId.length > 0) {
                this.calendarControlId = props.CalendarControlId;
            }
        }

        $(window).on("resize.sidemenu", () => this.debounceResize());
    }

    public componentDidUpdate(prevProps: ISidebarProps): void {
        // recreate calendar if we switch from create to search view
        if ((prevProps.Model.get("IsCreateMode") || prevProps.Model.get("IsAdvancedSearchView")) && !this.props.Model.get("IsCreateMode")) {
            this.setupCalendar();
        }
        if (this.props.Model.get("IsOpen")) {
            this.debounceResize();
        }
    }

    public componentWillUpdate(nextprops: ISidebarProps): void {
        // destroy calendar events if we switch from search to create view
        if ((this.props.Model.get("IsCreateMode") === false) && (nextprops.Model.get("IsCreateMode") === true)) {
            $("#" + this.calendarControlId).data("kendoCalendar").destroy();
        }

        if (this.props.Model.get("IsOpen") === false && nextprops.Model.get("IsOpen") === true) {
            window.setTimeout(() => $("#__patientSearchField").focus(), 50);
        }
    }

    public componentDidMount(): void {
        this.setupCalendar();
        if (this.props.Model.get("IsOpen")) {
            this.debounceResize();
        }

        window.setTimeout(() => this.onComponentDidMount(), 200);
    }

    public componentWillUnmount(): void {
        $("#" + this.calendarControlId).data("kendoCalendar")?.destroy();
        $(window).off("resize.sidemenu");
        this.turnOffKeyboardEvents();
    }

    public componentWillReceiveProps(nextProps: ISidebarProps): void {
        if (nextProps.Model.get("IsOpen") === false) {
            this.turnOffKeyboardEvents();
        }
        if (nextProps.Model.get("SelectedDate") !== this.props.Model.get("SelectedDate")) {
            $("#" + this.calendarControlId).data("kendoCalendar")?.value(nextProps.Model.get("SelectedDate"));
        }
    }

    public render(): JSX.Element {
        let createMode = this.props.Model.get("IsCreateMode");
        let selectedPatientId = this.props.Model.get("SelectedPatientId");

        const employee = sessionStore.getCurrentEmployee().toPerson();

        const employeeRamqNumber = RAMQInfo.ResolveRamqNumber(employee.EmployeeModel).slice(0, 6);

        const enrolledPatientResults: JSX.Element[] = [];
        const patientResults: JSX.Element[] = [];

        const patients = this.props.Model.get("SearchResultsPatients")?.toArray();

        for (let i = 0; i < patients.length; i++) {
            const patient = patients[i];
            if (
                cacheStore.ClinicSettings.EnablePatientSearchEnrollmentPrioritization && (
                    (employeeRamqNumber.length === 6 && patient.EnrollingPhysicianLicence === employeeRamqNumber) ||
                    (employeeRamqNumber.length === 6 && patient.EnrollingDelegateLicence === employeeRamqNumber)
                )
            ) {
                const patientResult = this.renderPatientResult(patient, selectedPatientId, i, true);
                enrolledPatientResults.push(patientResult);
            }
            else {
                const patientResult = this.renderPatientResult(patient, selectedPatientId, i);
                patientResults.push(patientResult);
            }
        }

        var patientEdit: JSX.Element;

        if (createMode) {
            patientEdit = (
                <PatientEdit
                    id="sbar"
                    cssClass="sidebar"
                    cancelOperation={LocalOperations.Sidebar.CreatePatient_Cancel}
                    patientModel={this.props.Model.get("PatientCreationModel")}
                    saveOperation={LocalOperations.Sidebar.CreatePatient_Save}
                    duplicatePromptLabelName="DuplicateSentencePromptSidebarLabel"
                    duplicateContinueOperation={LocalOperations.Sidebar.Select_Patient_Duplicate}
                    hideFooter={false}
                />
            );
        }

        var disabledResultClassName = "";

        if (this.props.SearchResultClickDisabled)
            disabledResultClassName = "disabled-results";

        let styleParent: React.CSSProperties = { minHeight: "720px" };
        if (createMode == true)
            styleParent.overflowY = "auto";

        return (
            <div id="__sbc" className="sidebar-container" onMouseOver={this.activateKeyboardEvents.bind(this)} onMouseOut={this.turnOffKeyboardEvents.bind(this)} style={styleParent}>
                {!createMode && (
                    <div id="__topcst" className="clearfix">
                        <div className="search-field">
                            <div className="gf">
                                <span className="glyphicon glyphicon-search" />
                            </div>
                            <input
                                data-cy="sidebar-patient-search"
                                type="text"
                                id="__patientSearchField"
                                value={this.props.Model.get("SearchText")}
                                onChange={e => this.onSearchTextChange(e.target.value)}
                                placeholder={cacheStore.GetString("SearchLabel")}
                            />
                        </div>
                        <div className="patient-create-options flex-container">
                            <div>
                                <div className="checkbox">
                                    <label>
                                        <input type="checkbox" checked={this.props.Model.get("SearchIsInactiveSelected")} onChange={() => LocalEvent.Dispatch(LocalOperations.Sidebar.SearchIsInactiveChanged)} />
                                        {cacheStore.GetString("DeactivatedFilesLabel")}
                                    </label>
                                </div>
                                {cacheStore.ClinicSettings.EnableRelations && (
                                    <div className="checkbox">
                                        <label>
                                            <input type="checkbox" checked={this.props.Model.get("SearchInRelativesSelected")} onChange={() => LocalEvent.Dispatch(LocalOperations.Sidebar.SearchInRelativesChanged)} />
                                            {cacheStore.GetString("ExternalRelationsLabel")}
                                        </label>
                                    </div>
                                )}
                                {cacheStore.ClinicSettings_Portal.EnablePortalWebsite && (
                                    <div className="checkbox">
                                        <label>
                                            <input type="checkbox" checked={this.props.Model.get("SearchInPortalSelected")} onChange={() => LocalEvent.Dispatch(LocalOperations.Sidebar.SearchInPortalChecked)} />
                                            {cacheStore.GetString("PortalSearchLabel")}
                                        </label>
                                    </div>
                                )}
                            </div>
                            <div>
                                {patientStore.CanCreatePatient && (
                                    <div>
                                        {/** quick hack to disable patient edit for certain clinics... **/}
                                        <ButtonImageControl
                                            onClick={() => sessionStore.dispatch(LocalOperations.Sidebar.CreatePatient)}
                                            imagePath={img_icon_create_patient}
                                            id="createPatient"
                                            dataCy="sidebar-createPatient-button"
                                        />
                                    </div>
                                )}
                                {cacheStore.ClinicSettings.EnableExternalPatientSearch &&
                                    <a onClick={this.onExternalSearchClick.bind(this)}>{cacheStore.GetString("ExternalSearchLabel")}</a>
                                }
                            </div>
                        </div>
                    </div>
                )}

                {!createMode && (
                    <div>
                        <div className="arrow-down" />
                        <div className="arrow-down-inner" />
                        <div id="search-result" className={disabledResultClassName}>
                            <div
                                id="patientContainer"
                                data-cy="sidebar-patients-div"
                                className="patient-sidebar-search-container"
                                style={{ "minHeight": "190px" }}
                            >
                                {enrolledPatientResults.length > 0 && (
                                    <div>
                                        <p className="enrolled-title">{cacheStore.GetString("YourPatientsLabel")}</p>
                                        {enrolledPatientResults}
                                    </div>
                                )}
                                <div>
                                    {patientResults}
                                </div>
                            </div>
                            <div id="showAdvanceSearchResults" data-cy="sidebar-showAdvanceSearch-div"><a onClick={this.onToggleAdvancedSearch.bind(this)}>{cacheStore.GetString("ShowAdvancedSearchResultsLabel")}</a></div>
                        </div>
                    </div>
                )}

                {createMode && <div style={{ marginTop: "30px" }}>{patientEdit}</div>}

                {!createMode && (
                    <div id="___clonsmscr">
                        <div className="search-results-footer">
                            <ul className="sb-img-collection clearfix bottom-left-round-corner">
                                <li data-cy="sidebar-calendar-li"><Link to="/calendar" onClick={() => sessionStore.dispatch(LocalOperations.Calendar.ShowNoticeBoard, { showNoticeBoard: false })}><div className="sb-img walkin" /></Link></li>
                                {this.renderNoticeIcon()}
                            </ul>
                        </div>

                        <div className="sidebar-push-bottom">
                            <div className="sidebar-calendar-container">
                                <div id={this.calendarControlId} />
                            </div>

                            <div className="cal-header-container clearfix">
                                <div className="tb">
                                    <div className="tbc" style={{ width: "200px", marginRight: "10px" }}>
                                        <input className="form-control" id="____inpq" type="text" placeholder="yyyy-mm-dd" onBlur={this.onDateTextLeave.bind(this)} onKeyDown={this.onKeyPressInDateField.bind(this)} onChange={this.onDateTextChange.bind(this)} value={this.props.Model.get("DateInputText")} />
                                    </div>
                                    <div className="tbc autowidth">
                                        <ButtonControl
                                            variant="brand"
                                            onClick={() => sessionStore.dispatch(LocalOperations.Sidebar.Today_Click)}
                                            label={cacheStore.GetString("TodayLabel")}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        );
    }

    private renderPatientResult(patient: Person, selectedPatientId: Guid, index: number, isPatientEnrolled: boolean = false): JSX.Element {
        var portalStatusIndicator: JSX.Element = null;

        if (cacheStore.ClinicSettings_Portal.EnablePortalWebsite) {
            const portalButtonProps = PortalHelper.getPortalButtonPropsForRegistrationState(patient.PortalSyncState);

            portalStatusIndicator = portalButtonProps && (
                <PortalStatusIcon
                    className="sidebarportalbtn"
                    buttonSize="small"
                    {...portalButtonProps}
                />
            );
        }

        var email = "";
        if (
            this.props.Model.get("SearchInPortalSelected") &&
            patient.PortalPatient?.OwnerUserId &&
            patient.PortalPatient.EmailAddresses?.[0]
        ) {
            email = patient.PortalPatient.EmailAddresses[0].Email;
        }

        let sidebarItemClass = isPatientEnrolled ? "sidebar-item enrolled" : "sidebar-item";
        let tabIndex = 0;
        if (selectedPatientId && selectedPatientId == patient.ContactFacetId) {
            sidebarItemClass = sidebarItemClass.concat(" selected");
            tabIndex = -1;
        }

        return (
            <div
                tabIndex={tabIndex}
                key={"patient" + index}
                data-cy={`sidebar-patient-${index}`}
                className={sidebarItemClass}
                onClick={this.onSelectPatient.bind(this, patient)}
            >
                <div className="tb">
                    <div className="tbc logo">
                        <span className="myle-icon-24 person" />
                    </div>
                    <div className="tbc">
                        <div><span>{patient.Name}</span></div>
                        <div className="identifier-row">
                            <div><p>{patient.Identifier}</p></div>
                        </div>
                        {email.length > 0 && (
                            <div className="identifier-row">
                                <div title={email}> <p>{email}</p></div>
                            </div>
                        )}
                        {portalStatusIndicator}
                    </div>
                </div>
            </div>
        );
    }

    private renderNoticeIcon(): JSX.Element {
        if (!cacheStore.ClinicSettings.EnableCovidQuestionnaire)
            return <li className="last"><div className="sb-img annouce" /></li>;

        let unsubmittedCount = this.props.Model.get("UnsubmittedQuestionnairesCount");
        let positivesCount = this.props.Model.get("PositiveQuestionnaireResultCount");

        return (
            <li className="last" data-cy="sidebar-questionnaire-li">
                {unsubmittedCount > 0 && <div className="notice-unsubmitted-count">{unsubmittedCount}</div>}
                {positivesCount > 0 && <div className="notice-postives-count">{positivesCount}</div>}
                <Link to="/calendar" onClick={() => sessionStore.dispatch(LocalOperations.Calendar.ShowNoticeBoard, { showNoticeBoard: true })}><div className="sb-img annouce" /></Link>
            </li>
        );
    }

    private activateKeyboardEvents(): void {
        if (!this.keyEventBound) {
            $(document).on("keydown.sidebar", this.onKeyPress.bind(this));
            this.keyEventBound = true;
        }
    }

    private turnOffKeyboardEvents(): void {
        $(document).off("keydown.sidebar");
        this.keyEventBound = false;
    }

    private debounceResize(): void {
        var self = this;
        if (this.resizeTimeout !== -1) {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = -1;
        }
        this.resizeTimeout = window.setTimeout(() => { self.calculatePositionning(); }, 90);
    }

    private calculatePositionning(): void {
        if (this.props.Model.get("IsOpen")) {
            var h = $(window).height() - 50;
            $("#__sbc").css("height", h + "px");
            var ph = cacheStore.ClinicSettings_Portal.EnablePortalWebsite ? (h - 596) : (h - 576);
            $(".patient-sidebar-search-container").height(ph);
        }
    }

    private setupCalendar(): void {
        var self = this;
        $("#" + this.calendarControlId).kendoCalendar({
            culture: sessionStore.getUserLanguageCodeFull(),
            value: self.props.Model.get("SelectedDate"),
            change: function(e: kendo.ui.CalendarEvent) {
                var change = new LocalEvent(LocalOperations.Sidebar.Calendar_SelectDate);
                change.AddItem("value", e.sender.value());
                LocalEventDispatcher.dispatch(change);
            }
        });
    }

    private onDateTextLeave(): void {
        LocalEvent.Dispatch(LocalOperations.Sidebar.DateInput_Blur);
    }

    private onExternalSearchClick(): void {
        let op = new LocalEvent(LocalOperations.MainComponentViewOperations.DisplayExternalSearch);
        MainComponentStateDispatcher.dispatch(op);
    }

    private onDateTextChange(e: ChangeEvent<HTMLInputElement>): void {
        var val = e.target.value;
        var change = new LocalEvent(LocalOperations.Sidebar.DateInput_Changed);
        change.AddItem("value", val);
        LocalEventDispatcher.dispatch(change);
    }

    private onSelectPatient(patient: Person): void {
        var change = new LocalEvent(LocalOperations.Sidebar.Select_Patient);
        change.AddItem("person", patient);
        LocalEventDispatcher.dispatch(change);
    }

    private onSearchTextChange(searchString: string): void {
        sessionStore.dispatch(LocalOperations.Sidebar.SearchTextChanged, { value: searchString });
    }

    private onToggleAdvancedSearch(e: React.MouseEvent): void {
        e.preventDefault();
        LocalEvent.Dispatch(LocalOperations.Sidebar.ToggleAdvancedSearch);
    }

    private onKeyPress(e: JQueryEventObject): void {
        if (overlayStore.hasOverlay()) return;

        switch (e.keyCode) {
            case 27: // esc
                LocalEvent.Dispatch(LocalOperations.Sidebar.Close);
                break;
            case 38: // up
                LocalEvent.Dispatch(LocalOperations.Sidebar.SelectPreviousPatient);
                break;
            case 40: // down
                LocalEvent.Dispatch(LocalOperations.Sidebar.SelectNextPatient);
                break;
            case 13: // enter
                if (!$("#____inpq").is(":focus")) {
                    LocalEvent.Dispatch(LocalOperations.Sidebar.SelectPatientWithEnterKey);
                }
                break;
            case 8: // back
                break;
            default:
                break;
        }
    }

    private onKeyPressInDateField(e: React.KeyboardEvent): void {
        if (overlayStore.hasOverlay()) return;

        switch (e.keyCode) {
            case 13: // enter
                window.setTimeout(() => { $("#__patientSearchField").focus(); }, 50);
                break;

            default:
                break;
        }
    }

    private onComponentDidMount(): void {
        sessionStore.dispatch(LocalOperations.Sidebar.AutoOpenClose);
        sessionStore.dispatch(LocalOperations.Sidebar.Sidebar_LoadNotice_Counts);
    }
}

export { ISidebarProps, Sidebar };
